import Service from '@ember/service';
import { TrackedObject } from 'tracked-built-ins';
import { action } from '@ember/object';

export default class BackgroundTasksService extends Service {
  taskIds = new TrackedObject({});

  subscribe(taskId, { onComplete, onFail }) {
    this.taskIds[taskId] = { onComplete, onFail };
  }

  unsubscribe(taskId) {
    delete this.taskIds[taskId];
  }

  @action
  onComplete(taskId, resource) {
    let task = this.taskIds[taskId];
    if (task) {
      let { onComplete } = this.taskIds[taskId];
      onComplete(resource);
      this.unsubscribe(taskId);
    }
  }

  @action
  onFail(taskId, resource) {
    let task = this.taskIds[taskId];
    if (task) {
      let { onFail } = this.taskIds[taskId];
      onFail(resource);
      this.unsubscribe(taskId);
    }
  }
}
